/**
 * Método que permite unicamente registar números
 * @param {String} e 
 * @param {Array} data 
 * @param {Function} setData 
 */
export default function campoExclusivoNumerosCP(e, data, setData) {

    let direccion;
    const { direcciones } = data;
    direcciones === undefined ? direccion = {} : [direccion] = direcciones;

    if (!/^[0-9]*?[0-9]*$/.test(e.substring(e.length - 1))) e = e.replace(/.$/, "");
    setData({ ...data, direcciones: [{ ...direccion, codigoPostal: e }] });
}